export enum LocalStorage {
  TOKEN = 'token',
  PROFILE_TYPE = 'profileType',
  PROFILE_ID = 'profileId',
  PARTNER_ID = 'partnerId ',
  PLACE_ID = 'placeId',
  PWA_POPUP = 'pwaPopup',
  USER_ID = 'userId'
}
